module.exports = __webpack_public_path__ + "static/media/Fichier 25.f2995e22.svg";